export enum ContractStatus {
  /** 契約締結前 */
  Previous = 1,
  /** 契約完了 */
  Completed = 2,
  /** 契約解除 */
  Canceled = 3,
}
